module.exports = __webpack_public_path__ + "img/coverage.b4dd7b97.png";